// extracted by mini-css-extract-plugin
export default {"search-form":"Search_search-form__hVPtO"};